import * as React from 'react';

export const ApiKeyContext = React.createContext({
  apiKey: '',
  useApiKeyInPaths: true,
});
